// Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT license.
// See LICENSE in the project root for license information.

export { PLUGIN_NAME as PluginName, STAGE_LOAD_LOCAL_CONFIG } from './shared';

export type {
  IWebpackConfigurationWithDevServer,
  IWebpackConfiguration,
  IWebpackConfigurationFnEnvironment,
  IWebpackPluginAccessor,
  IWebpackPluginAccessorHooks,
  IWebpackPluginAccessorParameters
} from './shared';
